import styled from 'styled-components';

const ThankYouStyles = styled.section`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    min-height: 40.9625rem;
    width: 100%;
    max-width: ${theme.maxWidths.header};
    margin: auto;
    height: auto;

    .thank-you-back-link {
      text-decoration: none;
      color: ${theme.colors.vmfGreen2};
      font-size: 1rem;
      font-weight: 700;
      display: inline-flex;
      margin-bottom: 1.8rem;

      svg {
        width: 1rem;
        height: 1rem;
        margin-right: 0.4375rem;
        margin-top: -0.08rem;
        transform: rotate(180deg);
      }
      
    }

    .thank-you-content {
      box-sizing: border-box;
      width: 50%;
      padding: 4.1875rem 5.2rem 0 7.351875rem;
      
      h1 {
        color: ${theme.colors.darkBlue};
        font-size: ${theme.type.large};
        margin: 0;
        margin-bottom: 1.2rem;
      }

      p {
        max-width: 34.89rem;
        margin: 0;
        font-weight: 400;
        font-size: ${theme.type.paragraph.intro};
        color: ${theme.colors.grey1};
        line-height: 32px;
      }
      
    }

    .thank-you-media {
      height: auto;
      width: 50%;
      position: relative;
      min-height: 41.116875rem;

      picture {
        width: 100%;
        height: 100%;
        position: absolute;

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
        
      }
      
    }

    @media (max-width: ${theme.breakpoints.desktop}) {
      min-height: 30rem;
      
      .thank-you-content {
        width: 100%;
        padding: 4.1875rem 6.25rem;

        p {
          max-width: initial;
        }
        
      }
      
      .thank-you-media {
        display: none;
      }

    }

    @media (max-width: ${theme.breakpoints.tablet}) {
      .thank-you-content {
        padding: 4.1875rem ${theme.padding.inner};
      }
    }

    @media (prefers-reduced-motion: no-preference) {
      
      .thank-you-back-link svg {
        transition: transform 0.2s;
        transform: translateX(0rem) rotate(180deg);
      }

      .thank-you-back-link:hover {
        svg {
          transform: translateX(-.4rem) rotate(180deg);
        }
      }

    }
    
  `}
`;

export default ThankYouStyles;
